import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import AppIcon from '../images/icon.png';
import { Link } from 'react-router-dom';
import chesssLogo from '../images/chessslogo.png';
import LandingImage from '../images/landback1.png';

// MUI Stuff
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
// Redux stuff
import { connect } from 'react-redux';
import { loginUser } from '../redux/actions/userActions';
// Rate limiting
import { checkRateLimit } from '../util/rateLimiter';
import { getRateLimit, buildGlobalRateKey } from '../util/rateLimitConfig';

const styles = (theme) => ({
  form: theme.form,
  image: theme.image,
  pageTitle: theme.pageTitle,
  textField: theme.textField,
  customError: theme.customError,
  button: theme.button,
  progress: theme.progress,
});

class login extends Component {
  constructor() {
    super();
    this.state = {
      identifier: '',
      password: '',
      errors: {},
      rateLimitError: ''
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.UI.errors) {
      this.setState({ errors: nextProps.UI.errors });
    }
  }
  handleSubmit = (event) => {
    event.preventDefault();

    // Client-side validation before submission
    const errors = {};

    if (!this.state.identifier) errors.identifier = 'Username or Email is required';
    if (!this.state.password) errors.password = 'Password is required';

    // Check if there are validation errors
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    // Rate limiting check for login attempts
    const config = getRateLimit('SIGNIN_ATTEMPT', 'free');
    const rateKey = buildGlobalRateKey('anonymous', 'signin_attempt');
    
    const isLimited = checkRateLimit({
      key: rateKey,
      limit: config.limit,
      windowMs: config.windowMs
    });

    if (isLimited) {
      this.setState({ 
        rateLimitError: 'Too many login attempts. Please wait then try again.',
        errors: {}
      });
      return;
    }

    // Clear any previous rate limit errors
    this.setState({ rateLimitError: '' });

    const userData = {
      identifier: this.state.identifier,
      password: this.state.password
    };
    this.props.loginUser(userData, this.props.history);
  };
  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };
  render() {
    const {
      classes,
      UI: { loading }
    } = this.props;
    const { errors, rateLimitError } = this.state;
    const { identifier, password } = this.state;
    const isFormValid = identifier.trim() !== '' && password.trim() !== '';
    const isDisabled = loading || !isFormValid;

    return (

      <div className="app-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div
          className="login-container"
          style={{}}




        >
          <Grid
            container
            className={classes.form}
            style={{
              border: '5px solid gold',
              margin: '0px',
              width: '100%',
              maxWidth: '600px',
              minHeight: '500px',
              padding: '20px',
              backgroundColor: 'lightslategray',
              position: 'relative',
              zIndex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >

            <Grid item style={{
              width: '100%',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}>

              <img
                src={chesssLogo}
                alt="app-icon"
                className={classes.image}
                style={{
                  maxWidth: '100px',
                  height: 'auto',

                }}
              />
              <div style={{
                color: 'gold',
                fontSize: 'clamp(24px, 5vw, 40px)',

                fontWeight: 'bold'
              }}>
                Login
              </div>

              <div style={{ width: '100%', maxWidth: '400px', margin: 'auto' }}>
                <form noValidate onSubmit={this.handleSubmit}>
                  {/* Rate limit error message */}
                  {rateLimitError && (
                    <div style={{
                      color: 'white',
                      backgroundColor: '#ff6b6b',
                      padding: '10px',
                      borderRadius: '4px',
                      marginBottom: '20px',
                      width: '90%',
                      fontWeight: 'bold',
                      textAlign: 'center',
                      fontSize: '14px',
                      margin: '0 auto 20px auto'
                    }}>
                      {rateLimitError}
                    </div>
                  )}

                  {/* Form-level error message */}
                  {/* {Object.keys(errors).length > 0 && (
                    <div style={{
                      color: 'white',
                      backgroundColor: '#ff0000',
                      padding: '10px',
                      borderRadius: '4px',
                      marginBottom: '20px',
                      width: '90%',
                      fontWeight: 'bold',
                      textAlign: 'center',
                      fontSize: '16px',
                      margin: '0 auto 20px auto'
                    }}>
                      Please fix the errors below to continue
                    </div>
                  )} */}

                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '5px',
                    width: '100%',
                    marginBottom: '20px',
                    marginTop: '10px'
                  }}>
                    <div style={{
                      color: 'black',
                    
                      fontWeight: 'bold',
                      fontSize: 'clamp(16px, 2vw, 20px)'
                    }}>Username or Email</div>
                    <input
                      id="identifier"
                      name="identifier"
                      type="text"
                      placeholder="Username or Email"
                      helperText={errors.identifier}
                      error={errors.identifier ? true : false}
                      value={this.state.identifier}
                      onChange={this.handleChange}
                      style={{
                        width: '90%',
                        padding: '15px',
                        fontSize: 'clamp(16px, 2vw, 20px)',
                        border: errors.identifier ? '5px solid #ff0000' : '5px solid black',
                        borderRadius: '4px',
                        background: 'white'
                      }}
                    />

                    {errors.identifier && (
                      <div style={{
                        color: '#ff0000',
                        fontSize: '14px',
                        marginTop: '5px',
                        textAlign: 'left',
                        width: '90%',
                        fontWeight: 'bold',
                        marginBottom: '10px'
                      }}>
                        {errors.identifier}
                      </div>
                    )}

                    <div style={{
                      color: 'black',
                      
                      fontWeight: 'bold',
                      fontSize: 'clamp(16px, 2vw, 20px)',
                      marginTop: '10px'
                    }}>Password</div>
                    <input
                      id="password"
                      name="password"
                      type="password"
                      placeholder="Password"
                      helperText={errors.password}
                      error={errors.password ? true : false}
                      value={this.state.password}
                      onChange={this.handleChange}
                      style={{
                        width: '90%',
                        padding: '15px',
                        fontSize: 'clamp(16px, 2vw, 20px)',
                        border: errors.password ? '5px solid #ff0000' : '5px solid black',
                        borderRadius: '4px',
                        background: 'white'
                      }}
                    />

                    {errors.password && (
                      <div style={{
                        color: '#ff0000',
                        fontSize: '14px',
                        marginTop: '0px',
                        textAlign: 'left',
                        width: '90%',
                        fontWeight: 'bold'
                      }}>
                        {errors.password}
                      </div>
                    )}
                  </div>
                  {errors.general && (
                    <div style={{
                      color: '#ff0000',
                      fontSize: '16px',
                      marginTop: '10px',
                      textAlign: 'center',
                      padding: '10px',
                      backgroundColor: 'rgba(255, 0, 0, 0.1)',
                      border: '1px solid #ff0000',
                      borderRadius: '4px',
                      width: '90%',
                      fontWeight: 'bold'
                    }}>
                      {errors.general}
                    </div>
                  )}

                  <button
                    type="submit"
                    style={{
                      width: '70%',
                      padding: '15px',
                      fontSize: 'clamp(16px, 2vw, 20px)',
                      backgroundColor: isDisabled ? '#6c757d' : '#ff0050',
                      border: isDisabled ? '3px solid #6c757d' : '3px solid gold',
                      color: isDisabled ? '#ddd' : 'gold',
                      borderRadius: '5px',
                      cursor: isDisabled ? 'not-allowed' : 'pointer',
                      fontWeight: 'bold',
                      opacity: isDisabled ? 0.7 : 1,
                      marginTop: '20px'
                    }}
                    disabled={isDisabled}
                  >
                    LOGIN
                    {loading && (
                      <CircularProgress size={30} className={classes.progress} />
                    )}
                  </button>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '15px',
                    alignItems: 'center',
                    marginTop: '25px'
                  }}>
                    <div style={{
                      fontSize: 'clamp(16px, 2vw, 24px)',
                      color: 'gold',
                      fontWeight: 'bold'
                    }}>
                      New Here? <Link to="/signup" style={{ color: 'gold', textDecoration: 'underline', fontWeight: 'normal' }}>Get Started.</Link>
                    </div>
                    <div style={{
                      fontSize: 'clamp(14px, 1.5vw, 16px)',
                      color: 'blue',
                    }}>
                      Forgot Password? <Link to="/reset-password" style={{ color: '', textDecoration: 'underline', fontWeight: 'normal' }}>Reset It.</Link>
                    </div>
                  </div>
                </form>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

login.propTypes = {
  classes: PropTypes.object.isRequired,
  loginUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  user: state.user,
  UI: state.UI
});

const mapActionsToProps = {
  loginUser
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withStyles(styles)(login));
